import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbModule,
  NgbPopoverModule,
  NgbTooltipModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  I18nModule,
  provideConfig,
  provideDefaultConfig,
} from '@spartacus/core';
import { FileUploadModule, MediaModule } from '@spartacus/storefront';
import { CustomUserRegistrationModule } from 'src/app/custom-user-registration/custom-user-registration.module';
import { CustomPipesModule } from '../../pipes/custom-pipes.module';
import { CustomFileUploadModule } from '../file-upload/file-upload.module';
import { TermsConditionsModule } from '../terms-conditions/terms-conditions.module';
import { TermsConditionsComponent } from '../terms-conditions/terms-conditions/terms-conditions.component';
import { CheckoutComponent } from './checkout.component';
import { WholesalerPharmacyModule } from 'src/app/custom-influenza/wholesaler-pharmacy';
import { checkoutApiConfig } from '../../config';
import { PharmacyAssociationModule } from 'src/app/custom-influenza/pharmacy-association/pharmacy-association.module';

@NgModule({
  declarations: [CheckoutComponent],
  exports: [CheckoutComponent],

  imports: [
    CommonModule,
    NgbTooltipModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    CustomUserRegistrationModule,
    I18nModule,
    NgbPopoverModule,
    NgbModule,
    TermsConditionsModule,
    FontAwesomeModule,
    CustomPipesModule,
    CustomFileUploadModule,
    FileUploadModule,
    WholesalerPharmacyModule,
    MediaModule,
    PharmacyAssociationModule,
  ],
  providers: [
    provideDefaultConfig(checkoutApiConfig),
    provideConfig({
      cmsComponents: {
        checkoutPage: {
          component: TermsConditionsComponent,
        },
      },
    }),
  ],
})
export class CheckoutModule {}
